export { LazyImage } from './lazy-image.component';
export type { ILazyImageProps } from './lazy-image.component';
